import { toast } from 'react-hot-toast';
import { useCallback } from 'react';

export const useToasts = () => {
  const showSuccess = useCallback((message) => {
    toast.success(message);
  }, []);

  const showError = useCallback((message) => {
    toast.error(message);
  }, []);

  const showInfo = useCallback((message) => {
    toast(message);
  }, []);

  return {
    showSuccess,
    showError,
    showInfo,
  };
};
